import {
    HttpHandler,
    HttpRequest,
    HttpEvent,
    HttpInterceptor
} from "@angular/common/http";
import { Observable, of, timeout } from "rxjs";
import { Injectable } from "@angular/core";
import { AuthService } from "../services/auth/auth.service";
import { environment } from "src/environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private _authService : AuthService) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const UserRole = this._authService.getUserRole();
        const UserId = this._authService.getUserId();
        const userRoleUI = document.querySelector("#userRole")?.innerHTML;
        if(userRoleUI && userRoleUI.toLowerCase() !== UserRole?.toLowerCase()) {
            location.reload();
            return of();
        }
        if (!!UserRole && !!UserId && request?.url.includes('authenticate')) {
            request = request.clone({
                setHeaders: {
                    UserId,
                    UserRole,
                    'Accept': 'application/json'
                }
            });
        } else if(request.url.includes(`${environment.iTracerApi}/FindUserGuid?UserGuid=`) || request.url.includes(`${environment.iTracerApi}/DeleteGuidVendor`) ){
            request = request?.clone({
                setHeaders: {
                    'Authorization': 'Bearer ' + this._authService.getIpepAccessToken(),
                    'Accept': 'application/json'
                }
            });
        } else {            
            request = request?.clone({
                setHeaders: {
                    'Authorization': 'Bearer ' + this._authService.getAccessToken(),
                    'Accept': 'application/json'
                }
            });
        }
        return next.handle(request).pipe(timeout(900000));
    }
}
